import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import ModalPortal from './ModalPortal';

interface GatewaySwitchWarningModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    targetGatewayName: string;
    isProcessing: boolean;
}

const GatewaySwitchWarningModal: React.FC<GatewaySwitchWarningModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    targetGatewayName,
    isProcessing
}) => {
    if (!isOpen) return null;

    return (
      <ModalPortal>
        <div
            className="fixed inset-0 z-1100 flex items-center justify-center bg-black/60 backdrop-blur-xs p-4 animate-in fade-in duration-200"
            onClick={(e) => {
                if (e.target === e.currentTarget && !isProcessing) onClose();
            }}
        >
            <div className="bg-[#0e0e10] border border-red-500/30 rounded-2xl w-full max-w-md shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200">
                <div className="p-6 border-b border-white/10 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="p-2 rounded-lg bg-red-500/10 text-red-500">
                            <AlertTriangle className="w-6 h-6" />
                        </div>
                        <h3 className="text-lg font-bold text-white">Switch Account?</h3>
                    </div>
                    <button
                        onClick={onClose}
                        disabled={isProcessing}
                        className="text-muted hover:text-white transition disabled:opacity-50"
                    >
                        <X className="w-5 h-5" />
                    </button>
                </div>

                <div className="p-6 space-y-4">
                    <p className="text-gray-300">
                        You are about to switch the active gateway to <span className="font-bold text-white">{targetGatewayName}</span>.
                    </p>

                    <div className="bg-red-500/10 border border-red-500/20 rounded-xl p-4">
                        <p className="text-sm text-red-200 font-medium">
                            ⚠️ Warning: This will deactivate and stop your current account's gateway. Any active trading sessions will be disconnected.
                        </p>
                    </div>

                    <p className="text-sm text-muted">
                        Are you sure you want to proceed?
                    </p>
                </div>

                <div className="p-6 pt-2 flex gap-3">
                    <button
                        onClick={onClose}
                        disabled={isProcessing}
                        className="flex-1 px-4 py-3 rounded-xl border border-white/10 text-white hover:bg-white/5 transition font-medium disabled:opacity-50"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={isProcessing}
                        className="flex-1 px-4 py-3 rounded-xl bg-red-500 hover:bg-red-600 text-white font-bold transition shadow-lg shadow-red-500/20 disabled:opacity-50 flex items-center justify-center gap-2"
                    >
                        {isProcessing ? 'Switching...' : 'Yes, Switch Account'}
                    </button>
                </div>
            </div>
        </div>
      </ModalPortal>
    );
};

export default GatewaySwitchWarningModal;
